module.exports = __webpack_public_path__ + "img/logo_headway_it.afb12250.svg";